import React from "react";
import { Field, Formik } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormFooter from "forms/components/FormFooter";
import FormRow from "forms/components/FormRow";
import { RenderField, TextareaField } from "forms/fields";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import SubmitButton from "components/SubmitButton";
import Translate from "utils/translate";
import { isRequired } from "utils/validation";

import styles from "forms/forms.css";

const { t } = new Translate("FlyerContactModal");

const FlyerContactModal = ({ onClose, onSubmit }) => (
  <Modal onClose={onClose} width={500} isOpen>
    <ModalHeader onClose={onClose}>{t("title")}</ModalHeader>
    <ModalBody>
      <Formik
        onSubmit={onSubmit}
        render={({ handleSubmit, isSubmitting }) => (
          <form className={styles.form} onSubmit={handleSubmit}>
            <FormContainer>
              <FormRow columns={1}>
                <Field
                  component={RenderField}
                  label={t("user.name")}
                  name="name"
                  validate={isRequired}
                />
              </FormRow>
              <FormRow columns={1}>
                <Field
                  component={RenderField}
                  label={t("user.email")}
                  name="email"
                  type="email"
                  validate={isRequired}
                />
              </FormRow>
            </FormContainer>
            <FormContainer>
              <FormRow columns={1}>
                <Field
                  border="left"
                  component={TextareaField}
                  name="question"
                  placeholder={t("question")}
                  rows={6}
                  validate={isRequired}
                />
                <p className={styles.info}>{t("info")}</p>
              </FormRow>
              <FormFooter>
                <SubmitButton
                  isSubmitting={isSubmitting}
                  submitLabel={t("send")}
                  submittingLabel={t("sending")}
                />
              </FormFooter>
            </FormContainer>
          </form>
        )}
      />
    </ModalBody>
  </Modal>
);

FlyerContactModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default FlyerContactModal;
